import _extends from "@babel/runtime/helpers/esm/extends";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Components as SidebarComponents } from './SidebarMenu.style';
import Typography from '../../Typography';
const SidebarCollapsedMenu = _ref => {
  let {
    activeNav,
    item,
    selectedMenuItems,
    subMenuRef,
    minWidth,
    theme,
    onNavClick,
    onMenuItemClick,
    onCollapseSubMenu
  } = _ref;
  return _jsx(SidebarComponents.CollapsedMenu, _extends({
    ref: subMenuRef,
    minWidth: minWidth,
    themeMode: theme
  }, {
    children: (item === null || item === void 0 ? void 0 : item.subMenu) && (item === null || item === void 0 ? void 0 : item.subMenu.map((subItem, idx) => {
      const isSubMenuActive = selectedMenuItems.includes((subItem === null || subItem === void 0 ? void 0 : subItem.id) || '');
      const isActiveNav = activeNav === (subItem === null || subItem === void 0 ? void 0 : subItem.id);
      return _jsxs(SidebarComponents.SubMenuListItem, _extends({
        className: "sidebar-sub-menu",
        isActiveNav: isActiveNav,
        onClick: e => {
          var _a;
          e.stopPropagation();
          e.preventDefault();
          if (((_a = subItem === null || subItem === void 0 ? void 0 : subItem.childSubMenu) === null || _a === void 0 ? void 0 : _a.length) && (subItem === null || subItem === void 0 ? void 0 : subItem.id) && (item === null || item === void 0 ? void 0 : item.id)) {
            onMenuItemClick(subItem === null || subItem === void 0 ? void 0 : subItem.id);
            onCollapseSubMenu([item.id, subItem.id]);
          } else {
            onNavClick && onNavClick(subItem.path, subItem, e);
            (item === null || item === void 0 ? void 0 : item.id) && onCollapseSubMenu([item.id]);
          }
        }
      }, {
        children: [_jsxs(SidebarComponents.SubMenuContent, _extends({
          isExpanded: false,
          isActiveNav: isActiveNav,
          themeMode: theme
        }, {
          children: [_jsx(Typography, _extends({
            variant: "body2"
          }, {
            children: subItem.title || 'N/A'
          })), subItem.childSubMenu && _jsx(SidebarComponents.DropdownIcon, {
            name: isSubMenuActive ? 'chevron-down' : 'chevron-right',
            themeMode: theme
          })]
        })), isSubMenuActive && subItem.childSubMenu ? _jsx(SidebarComponents.CollapsedMenu, _extends({
          isSubChildMenu: isSubMenuActive,
          themeMode: theme
        }, {
          children: subItem.childSubMenu.map((subChildItem, idx) => {
            const isActiveNav = activeNav === (subChildItem === null || subChildItem === void 0 ? void 0 : subChildItem.id);
            return _jsx(SidebarComponents.SubMenuListItem, _extends({
              className: "sidebar-sub-child-menu",
              isActiveNav: isActiveNav,
              onClick: e => {
                e.stopPropagation();
                e.preventDefault();
                onNavClick && onNavClick(subChildItem.path, subChildItem, e);
                (item === null || item === void 0 ? void 0 : item.id) && subItem.id && onCollapseSubMenu([item.id, subItem.id]);
              }
            }, {
              children: _jsx(SidebarComponents.SubMenuContent, _extends({
                isActiveNav: isActiveNav,
                themeMode: theme
              }, {
                children: _jsx(Typography, _extends({
                  variant: "body2"
                }, {
                  children: subChildItem.title || 'N/A'
                }))
              }))
            }), idx);
          })
        })) : _jsx(_Fragment, {})]
      }), idx);
    }))
  }));
};
export default SidebarCollapsedMenu;